var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 9C1.25 7.48122 2.48122 6.25 4 6.25H20C21.5188 6.25 22.75 7.48122 22.75 9V15C22.75 16.5188 21.5188 17.75 20 17.75H4C2.48122 17.75 1.25 16.5188 1.25 15V9ZM4 7.75C3.30964 7.75 2.75 8.30964 2.75 9V15C2.75 15.6904 3.30964 16.25 4 16.25H20C20.6904 16.25 21.25 15.6904 21.25 15V9C21.25 8.30964 20.6904 7.75 20 7.75H4ZM4.25 9.5C4.25 9.08579 4.58579 8.75 5 8.75H8.5C8.91421 8.75 9.25 9.08579 9.25 9.5C9.25 9.91421 8.91421 10.25 8.5 10.25H5C4.58579 10.25 4.25 9.91421 4.25 9.5ZM4.25 12C4.25 11.5858 4.58579 11.25 5 11.25L13 11.25C13.4142 11.25 13.75 11.5858 13.75 12C13.75 12.4142 13.4142 12.75 13 12.75L5 12.75C4.58579 12.75 4.25 12.4142 4.25 12ZM15.25 12C15.25 11.5858 15.5858 11.25 16 11.25L19 11.25C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75L16 12.75C15.5858 12.75 15.25 12.4142 15.25 12ZM4.25 14.5C4.25 14.0858 4.58579 13.75 5 13.75H11C11.4142 13.75 11.75 14.0858 11.75 14.5C11.75 14.9142 11.4142 15.25 11 15.25H5C4.58579 15.25 4.25 14.9142 4.25 14.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.15f88a378ca5f38f7859f85efd949707.svg";
export { ForwardRef as ReactComponent };